import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=58ba45f3&scoped=true&"
import script from "./RefundPolicy.vue?vue&type=script&lang=ts&"
export * from "./RefundPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=58ba45f3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba45f3",
  null
  
)

export default component.exports